import axios from "axios";
import { getAuth } from "firebase/auth";

const api = axios.create({
  baseURL: "/api",
});

api.interceptors.request.use(async (config) => {
  const user = getAuth().currentUser;
  if (user) {
    config.headers.Authorization = `Bearer ${await user.getIdToken()}`;
  }
  return config;
});

export default api;
